import { useEffect, useState } from "react";
import { Capacitor } from "@capacitor/core";

/**
 * Detects whether the app is running inside a Capacitor native shell (iOS/Android).
 * Web (mobile browsers included) returns false so marketing/SEO behaviour stays intact.
 */
export function useIsNative(): boolean {
  const [isNative, setIsNative] = useState<boolean>(() => {
    try {
      return Capacitor.isNativePlatform();
    } catch {
      return false;
    }
  });

  useEffect(() => {
    try {
      setIsNative(Capacitor.isNativePlatform());
    } catch {
      setIsNative(false);
    }
  }, []);

  return isNative;
}
